import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import Token from '../../abi/Ufo.json';
import { sendGetRequest, providerURL } from '../../../../helper/Helper';

const UfoBurnedTillNow = ({ ufoPrice }) => {
  const [UFOBurned, setUFOBurned] = useState({'24H': 0, '1W': 0, '1M': 0, '1Y': 0});
  const [burnBalance, setBurnBalance] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    getBurnStats();
  }, []);

  const getBurnStats = async () => {
    try {
      const response = await sendGetRequest('ufo/historical/burn');
      if (response && response.status === 200 && response.data) {
        setUFOBurned(prev => ({ ...prev, ...response.data }));
      }
      
      const web3 = new Web3(providerURL());
      const UFOContract = new web3.eth.Contract(Token.ABI, Token.Contract);
      setBurnBalance(parseInt(await UFOContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    } catch (error) {}
  };

  return (
    <div className="RewardsSec greysubcontent subcontent subPad">
      <div className="relative">
        <div className="row align-items-center">
          <div className="col-xl-12">
            <h2 className="gradient-stroke-text" data-aos="fade-up" data-aos-delay="1500" data-aos-duration="1400">
              UFO Burned Till Now
            </h2>
            <p className="mb-1" data-aos="fade-up" data-aos-delay="1700" data-aos-duration="1400">
              See the total number of UFO permanently removed from circulation through burns. Track deflationary progress and its impact on scarcity and long-term token value.
            </p>
          </div>

          <div className="col-xl-12" data-aos="fade-up" data-aos-delay="600" data-aos-duration="1400">
            <div className="row">
              {Object.keys(UFOBurned).map(label => (
                <div key={label} className="col-md-3 col-xl-6 mb-3">
                  <div className="boxes2 p-0 freesMulti">
                    <div className="result-single">
                      <div className="perVal textgreen fInter d-flex align-items-center flex-wrap mb-0">
                        <span>{label} Burn</span>
                      </div>
                      <h4 className="dollorValue value mb-0">
                        <span>{parseFloat(UFOBurned[label] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        <span className="dollor2">UFO</span>
                      </h4>
                      <div className="perVal fInter d-flex align-items-center flex-wrap">
                        <span>${parseFloat((UFOBurned[label] || 0) * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-md-3 col-xl-12 mb-0">
                <div className="boxes2 p-0 freesMulti">
                  <div className="result-single">
                    <div className="perVal textgreen fInter d-flex align-items-center flex-wrap mb-0">
                      <span>All Time Burn</span>
                    </div>
                    <h4 className="dollorValue value mb-0">
                      <span>{parseFloat(burnBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      <span className="dollor2">UFO</span>
                    </h4>
                    <div className="perVal fInter d-flex align-items-center flex-wrap">
                      <span>${parseFloat(burnBalance * ufoPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UfoBurnedTillNow;
